import type { SVGProps } from 'react';
export const DoubleCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M13 6.22c.27.28.26.73-.03 1L9 10.87a.8.8 0 0 1 .71.16l1.4 1.29 6.66-6.13a.75.75 0 0 1 1.03.03c.28.28.27.73-.03 1l-7.15 6.59a.75.75 0 0 1-1 0L8.7 12.05a.7.7 0 0 1-.19-.74l-2.7 2.5a.75.75 0 0 1-1.02 0l-3.57-3.3a.7.7 0 0 1-.03-1 .75.75 0 0 1 1.03-.02l3.08 2.83 6.65-6.13a.75.75 0 0 1 1.03.03"
      clipRule="evenodd"
    />
  </svg>
);
